import React, { memo } from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

let DealflowIcon = (props) => (
	<SvgIcon {...props} viewBox={"0 0 500 443"}>
		<title>Dealflow</title>
		<path
			d="M284.59 236.17L86.1 434.69c-7.88 7.88-20.65 7.88-28.53 0L8.46 385.57c-7.88-7.88-7.88-20.65 0-28.53L143.58 221.9l-79.21-79.21-55.91-55.9c-7.88-7.88-7.88-20.65 0-28.53L57.57 9.15c7.88-7.88 20.65-7.88 28.53 0L219.65 142.7l64.94 64.94c7.88 7.88 7.88 20.65 0 28.53z"
			fill="#00d8de"
		/>
		<path
			d="M221.18 144.29l-77.64 77.64-29.68-29.68-49.5-49.56-55.9-55.9c-7.88-7.88-7.88-20.65 0-28.53L57.57 9.15c7.88-7.88 20.65-7.88 28.53 0l105.41 105.46 29.67 29.68z"
			fill="#00a5ff"
		/>
		<path
			d="M221.18 144.29l-77.63 77.64-18.83-18.86 77.64-77.63z"
			fill="#0087ff"
		/>
		<path
			d="M491.54 236.17L293.05 434.69c-7.88 7.88-20.65 7.88-28.53 0l-49.11-49.11c-7.88-7.88-7.88-20.65 0-28.53L350.53 221.9l-79.21-79.21-55.91-55.91c-7.88-7.88-7.88-20.65 0-28.53l49.11-49.11c7.88-7.88 20.65-7.88 28.53 0L426.6 142.69l64.94 64.94c7.88 7.89 7.88 20.66 0 28.54z"
			fill="#00a5ff"
		/>
		<path
			d="M428.13 144.29l-77.64 77.64-29.68-29.68-49.5-49.56-55.91-55.91c-7.88-7.88-7.88-20.65 0-28.53l49.11-49.11c7.88-7.88 20.65-7.88 28.53 0L398.45 114.6l29.68 29.69z"
			fill="#00d8de"
		/>
	</SvgIcon>
);

DealflowIcon = memo(DealflowIcon);
DealflowIcon.displayName = "DealflowIcon";
DealflowIcon.muiName = "DealflowIcon";

export default DealflowIcon;
